import React from "react"

import AddIcon from "@mui/icons-material/Add"
import { Box, Button, FormControl, IconButton, Input, InputAdornment, InputLabel } from "@mui/material"
import SectionOutputModal from "./SectionOutputModal"
import DeleteIcon from "@mui/icons-material/Delete"
import { COLORS } from "../../../../../utils"

const SectionOutputPercentageModal = ({ open, onClose, onSubmit, section }) => {
  const [localPercentages, setLocalPercentages] = React.useState((
    section.sectionOutputs && section.sectionOutputs.filter(s => s.type === "percentage").length > 0 ?
      section.sectionOutputs
      : ["", ""]).map(output => output.percentage || ""))

  const handlePercentageChange = (index, value) => {
    const newPercentages = [...localPercentages]
    const normalized = value.replace(",", ".")
    const regex = /^\d*(\.\d*)?$/
    if (normalized === "" || regex.test(normalized)) {
      newPercentages[index] = normalized
    }
    setLocalPercentages(newPercentages)
  }

  const handleDeletePercentage = (index) => {
    const newPercentages = [...localPercentages]
    newPercentages.splice(index, 1)
    setLocalPercentages(newPercentages)
  }

  const handleSubmit = () => {
    onSubmit({
      sectionOutputs: localPercentages.map((percentage, index) => {
        return {
          percentage: percentage ? parseFloat(percentage) : 0,
          type: "percentage",
          index: section.sectionOutputs && section.sectionOutputs[index] && section.sectionOutputs[index].type == "percentage" ? section.sectionOutputs[index].index : null,
        }
      })
    })
  }

  return (
    <SectionOutputModal
      open={open}
      onClose={onClose}
      title="Diviser votre section en plusieurs parties en renseignant le pourcentage de chacune."
      onValidate={() => handleSubmit()}
      sx={{
        "& .MuiPaper-rounded": {
          maxWidth: 700,
          width: 700
        },
      }}
      disabled={!(localPercentages.every(v => v && parseFloat(v) > 0 && parseFloat(v) < 100) && localPercentages.reduce((acc, val) => acc + parseFloat(val), 0) === 100)}
      btnCloseLabel="Retour"
    >
      <div className="flex1">
        <div className="flexRow justifyEnd">
          <Button
            onClick={() => setLocalPercentages([...localPercentages, ""])}
            size="small"
            sx={{ padding: "0 4px", fontSize: 14, margin: "8px 0" }}
          >
            <AddIcon sx={{ marginRight: "10px" }} />
            Ajouter une nouvelle partie</Button>
        </div>
        {
          localPercentages.map((percentage, index) =>
            <Box key={index} className="flexRow center" sx={{ "&:not(:last-of-type)": { marginBottom: "16px" }, justifyContent: "space-between", alignItems: "center", fontSize: 14 }}>
              <div className="flexRow center flex1" style={{ gap: 8, marginTop: 16 }}>
                <span style={{ color: "#555" }}>Partie {index + 1}</span>
                <div className="flex1">
                  {index > 1 && <IconButton
                    onClick={() => handleDeletePercentage(index)}
                    title="Supprimer la ligne"
                    aria-label="Supprimer la ligne"
                    size="medium"
                  >
                    <DeleteIcon />
                  </IconButton>}
                </div>
              </div>
              <FormControl
                variant="standard"
              // sx={{ ".MuiInputAdornment-root *": { opacity: 0 }, "&:focus-within .MuiInputAdornment-root *": { opacity: 1 } }}
              >
                <InputLabel htmlFor={"standard-adornment-quantity" + index}>Répartition en %</InputLabel>
                <Input
                  sx={{ width: 150, fontSize: 14 }}
                  label="Répartition en %"
                  id={"standard-adornment-quantity" + index}
                  value={percentage}
                  onChange={(e) => handlePercentageChange(index, e.target.value)}
                  endAdornment={!!percentage && <InputAdornment position="end" sx={{ color: COLORS.BLACK_400 }}>%</InputAdornment>}
                  inputProps={{
                    "aria-label": "shippingFees",
                    inputMode: "numeric",
                    pattern: "[0-9]*"
                  }}
                />
              </FormControl>
            </Box>)
        }
      </div>
    </SectionOutputModal>
  )
}

export default SectionOutputPercentageModal